import React, { useState } from 'react';
import { COLORS, MATH } from 'Permafrost/index';
import { StyledProgressBar } from './ProgressBar.styles';
export const ProgressBar = (props) => {
    const { primary, secondary, className, id, style, onHoverDetails = null, primaryColor = COLORS.robinsEggBlue, secondaryColor = COLORS.red, } = props;
    const [tooltipData, setTooltipData] = useState(null);
    const [mouseCoordinates, setMouseCoordinates] = useState([-1, -1]);
    const primaryWidth = (primary, primaryColor) => {
        if (primary === 100) {
            return {
                width: 'calc(100% + 2px)',
                borderRadius: '5px',
                background: primaryColor,
            };
        }
        else if (primary === 0) {
            return {
                width: '0px',
            };
        }
        else {
            return {
                width: `calc(${primary}% + 1px)`,
                background: primaryColor,
            };
        }
    };
    const secondaryWidth = (primary, secondary, secondaryColor) => {
        if (MATH.round10(primary + secondary, -2) >= 100) {
            const reducedSecondary = 100 - primary;
            return {
                width: `calc(${reducedSecondary}% + 2px)`,
                borderRadius: '0 5px 5px 0',
                background: secondaryColor,
            };
        }
        else if (secondary === 0) {
            return {
                width: '0px',
            };
        }
        else {
            return {
                width: `calc(${secondary}% + 1px)`,
                background: secondaryColor,
            };
        }
    };
    return (React.createElement(StyledProgressBar, { className: `ProgressBar ${className || ''}`, "data-cy": props['data-cy'], id: id, style: style, onMouseLeave: () => {
            setTooltipData(null);
            setMouseCoordinates([-1, -1]);
        }, onMouseEnter: (e) => {
            setTooltipData(onHoverDetails);
            setMouseCoordinates([e.clientX, e.clientY]);
        }, onMouseMove: (e) => {
            e.persist();
            requestAnimationFrame(() => setMouseCoordinates([e.clientX, e.clientY]));
        } },
        React.createElement("div", Object.assign({ className: "progress-container" }, props === null || props === void 0 ? void 0 : props.progressBarRowProps),
            React.createElement("div", { className: "primary-progress", style: primaryWidth(primary, primaryColor) }),
            secondary ? (React.createElement("div", { className: "secondary-progress", style: secondaryWidth(primary, secondary, secondaryColor) })) : null),
        tooltipData && (React.createElement("div", { className: "progress-bar-tooltip", style: { top: mouseCoordinates[1], left: mouseCoordinates[0] } }, tooltipData))));
};
//# sourceMappingURL=ProgressBar.js.map